import { render, staticRenderFns } from "./BCDFreeAddressBlock.vue?vue&type=template&id=01fb5205"
import script from "./BCDFreeAddressBlock.vue?vue&type=script&lang=js"
export * from "./BCDFreeAddressBlock.vue?vue&type=script&lang=js"
import style0 from "./BCDFreeAddressBlock.vue?vue&type=style&index=0&id=01fb5205&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports